import { PlanetSkill, PlanetSkillPool, PlanetSkillType } from '@apeiron/planet'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { planetSkillSchema } from '@src/deserialize/yup/planet'
import * as R from 'ramda'

const useFetchPlanetSkillJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<PlanetSkillPool>({
    fetchNow,
    path: ENV_CONFIG.JSON_URL.CARD_SKILLS,
    deserialize: response => {
      const skillData = R.propOr({}, 'data', response)

      const setting = { domain: ENV_CONFIG.DOMAIN_URL.ASSET }

      const activeSkills = R.map(data => {
        return planetSkillSchema.cast(data, {
          context: { ...setting, data, type: PlanetSkillType.Active }
        }) as PlanetSkill
      }, R.propOr([], 'class_skills', skillData))

      const passiveSkills = R.map(data => {
        return planetSkillSchema.cast(data, {
          context: { ...setting, data, type: PlanetSkillType.Passive }
        }) as PlanetSkill
      }, R.propOr([], 'passive_skills', skillData))

      const bindPassiveSkills = R.map(data => {
        return planetSkillSchema.cast(data, {
          context: { ...setting, data, type: PlanetSkillType.PlanetPassive }
        }) as PlanetSkill
      }, R.propOr([], 'planet_passive_skills', skillData))

      const bindEnergizedSkills = R.map(data => {
        return planetSkillSchema.cast(data, {
          context: { ...setting, data, type: PlanetSkillType.PlanetEnergize }
        }) as PlanetSkill
      }, R.propOr([], 'planet_energized_skills', skillData))

      const autoAttack = R.map(data => {
        return planetSkillSchema.cast(data, {
          context: { ...setting, data, type: PlanetSkillType.AutoAttack }
        }) as PlanetSkill
      }, R.propOr([], 'auto_attack', skillData))

      return {
        autoAttack,
        active: activeSkills,
        passive: passiveSkills,
        bindPassive: bindPassiveSkills,
        bindEnergized: bindEnergizedSkills,
        allPassive: R.flatten([passiveSkills, bindPassiveSkills]),
        all: R.flatten([
          activeSkills,
          passiveSkills,
          bindPassiveSkills,
          bindEnergizedSkills
        ])
      }
    }
  })
}

export default useFetchPlanetSkillJson
